export class MilesUtilityHandler {
    static convertKmToMiles(km: number): number {
        return km * 1.60934;
    }
}
